import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
import {SplitText} from 'gsap/SplitText';
gsap.registerPlugin( ScrollTrigger, CustomEase, SplitText );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      $( `
      .js-fade:not(.js-ignore),
      .js-reveal:not(.js-ignore),
      .js-fade-group,
      .wysiwyg--animate
      ` ).each( function() {
        gsap.registerPlugin( ScrollTrigger );
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 95%',
            scrub: 0.15,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              if ( $( this ).hasClass( 'js-fade-group' ) || $( this ).hasClass( 'wysiwyg--animate' ) ) {
                $( this ).find( '> *' ).each( function( childKey, child ) {
                  const delay = ( childKey + 1 ) / 10;
                  child.style.setProperty( '--fade-group-delay', delay + 's' );
                } );
              }
              $( this ).addClass( 'js-animated' );
            },
          },
        } );
      } );

      const splitClasses = '.js-split-words:not(.js-ignore), .wysiwyg--animate .hdg-1:not(.js-ignore), .wysiwyg--animate .hdg-2:not(.js-ignore), .wysiwyg--animate .hdg-3:not(.js-ignore), .wysiwyg--animate .hdg-4:not(.js-ignore), .wysiwyg--animate .hdg-5:not(.js-ignore), .wysiwyg--animate .hdg-6:not(.js-ignore)';
      const split = new SplitText( splitClasses, {type: 'words'} );

      document.querySelectorAll( splitClasses ).forEach( ( el ) => {
        const split = new SplitText( el, {type: 'words'} );
        $( el ).addClass( 'js-split-words--target' );

        gsap.from( split.words, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
          stagger: 0.1, // Stagger each word
          scrollTrigger: {
            trigger: el,
            start: 'top 90%', // Triggers when the section enters the viewport
            toggleActions: 'play none none none', // Plays once when scrolled to
            onEnter: () => {
              $( el ).addClass( 'js-animated' );
            },
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( el ).addClass( 'js-animated' );
              }
            },
          },
        } );
      } );
    },
    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => {
        el.classList.remove( 'js-fade' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
